import { buildProductSearchMatcher } from './buildProductSearchMatcher';
import { groupProductLinesByCategory } from './groupProductLinesByCategory';

/**
 * Turn the flat catalog of the client into the groups the order table displays, narrowed the way
 * the draft form does: the search only reduces what is displayed — it never adds nor removes an
 * ordered line — and the summary mode narrows it further to the products carrying a quantity.
 *
 * @param {Array<Object>} catalog - The catalog lines of the client (product + price)
 * @param {Object} params
 * @param {string} params.search - The search input, matched on the product name and SKU
 * @param {Object} params.quantityByProductId - The quantities currently typed, keyed by product id
 * @param {boolean} params.isSummaryMode - Whether only the ordered lines must be kept
 *
 * @returns {Array<{ category: string, products: Array<Object> }>}
 */
export const buildCatalogCategoryGroups = (
  catalog,
  { search, quantityByProductId, isSummaryMode },
) => {
  const matchesSearch = buildProductSearchMatcher(search);

  const displayedProducts = catalog.filter((product) => {
    const { productId } = product;

    if (isSummaryMode && !quantityByProductId[productId]) {
      return false;
    }

    return matchesSearch(product);
  });

  return groupProductLinesByCategory(displayedProducts);
};
